import type { GraduatedToken } from '@cronos-app/api';
import { getGraduatedTokens } from '@cronos-app/api';
import { currentWallet } from '@cronos-app/wallet';
import { useQuery } from '@tanstack/react-query';

import { useGlobalChainLayer } from './useGlobalChainLayer';

export const useGraduatedTokens = () => {
  const account = currentWallet.useAccount();
  const chainLayer = useGlobalChainLayer();

  return useQuery<GraduatedToken[]>({
    queryKey: ['useGraduatedTokens', account, chainLayer],
    queryFn: () => {
      if (!account) throw new Error('Account is required');
      return getGraduatedTokens(account, chainLayer);
    },
    enabled: !!account,
  });
};
